import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default () => ({
  path: ":datasetId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "planning-insights" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
});
